import { KeyRound, ArrowRight, Loader2 } from 'lucide-react';
import {useEffect, useState} from "react";
import {createOtp, verifyOtp} from "../api/otp.ts";
import useDataStore from "../store/dataStore.ts";
import GoBackHeader from "../components/GoBackHeader.tsx";
import Routes from "../utils/routes.ts";
import {useNavigate} from "react-router-dom";
import PhoneNumberInput from "../components/PhoneNumberInput.tsx";

const OtpScreen = () => {
    const [step, setStep] = useState<'phone' | 'otp'>('phone');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);

    const [resendTimer, setResendTimer] = useState(0);
    const navigate = useNavigate();

    const RESEND_TIMER = 60

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [resendTimer]);

    /*useEffect(()=>{
        if (myPhoneNumber){
            navigate('/')
        }
    },[])*/

    const handlePhoneSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if(isPhoneValid){
            setLoading(true);
            const response = createOtp(phoneNumber);
            response.then(() => {
                setStep('otp');
                setResendTimer(RESEND_TIMER);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }
    };
    const resendOptCode = async () => {
        if(isPhoneValid){
            setLoading(true);
            const response = createOtp(phoneNumber);
            response.then(() => {
                setStep('otp');
                setResendTimer(RESEND_TIMER);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }
    };


    const handleOtpChange = (index: number, value: string) => {
        if (value?.length > 1) value = value[0];
        if (!/^\d*$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus next input
        if (value && index < 5) {
            const nextInput = document.getElementById(`otp-${index + 1}`);
            nextInput?.focus();
        }
    };

    const handleOtpSubmit = async () => {
        setLoading(true);
        const response = verifyOtp(phoneNumber, otp.join('') );
        response.then((res) => {
            if(res?.data?.status ==='SUCCESS'){
                savePhoneNumber();
                navigate(`/${Routes["Evenements de l'utilisateur"]}`)
            } else {
                alert(res?.data?.message);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const savePhoneNumber = () => {
        useDataStore.getState().setMyPhoneNumber(phoneNumber);
    }

    const handleResendOtp = async () => {
        if (resendTimer > 0) return;
        await resendOptCode();
    };

    const handleValidPhone = (fullNumber: string) => {
        setPhoneNumber(fullNumber);
    };

    return (
        <div
            style={{
                backgroundImage: `url('/pattern-white.svg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            className="min-h-screen py-4 px-2 flex flex-col justify-between"
        >
            <GoBackHeader onBackPress={() => navigate('/')}/>
                <div className="min-h-screen flex items-center justify-center p-4">
                    <div className="rounded-2xl shadow-xl w-full max-w-md p-8">
                        <div className="text-center mb-8">
                            <h1 className="text-2xl font-bold text-gray-800 mb-2">
                                {step === 'phone' ? 'Entrez votre numéro de téléphone' : 'Verification du code '}
                            </h1>
                            <p className="text-gray-600">
                                {step === 'phone'
                                    ? "Nous vous enverrons un code à usage unique"
                                    : `Entrez le code à 6 chiffres envoyé à ${phoneNumber}`}
                            </p>
                        </div>

                        {step === 'phone' ? (
                            <form onSubmit={handlePhoneSubmit} className="space-y-6">
                                <PhoneNumberInput
                                    setIsPhoneValid={setIsPhoneValid}
                                    onValidPhone={handleValidPhone}
                                    autoSet={false}
                                    required={true}
                                />
                                <button
                                    type="submit"
                                    disabled={loading && !isPhoneValid}
                                    className="w-full bg-primary text-white py-3 rounded-lg font-medium
                hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                                >
                                    {loading ? (
                                        <Loader2 className="h-5 w-5 animate-spin"/>
                                    ) : (
                                        <>
                                            <span>Envoyer l'OTP</span>
                                            <ArrowRight className="h-5 w-5"/>
                                        </>
                                    )}
                                </button>
                            </form>
                        ) : (
                            <form className="space-y-6">
                                <div className="flex justify-center space-x-3">
                                    {otp?.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            maxLength={1}
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Backspace' && !digit && index > 0) {
                                                    const prevInput = document.getElementById(`otp-${index - 1}`);
                                                    prevInput?.focus();
                                                }
                                            }}
                                            className="w-10 h-10 text-center text-xl font-semibold border border-gray-300 rounded-lg
                    focus:ring-2 focus:ring-primary focus:border-transparent"
                                        />
                                    ))}
                                </div>

                                <button
                                    onClick={handleOtpSubmit}
                                    disabled={loading || otp.some(digit => !digit)}
                                    className="w-full bg-primary text-white py-3 rounded-lg font-medium
                hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                                >
                                    {loading ? (
                                        <Loader2 className="h-5 w-5 animate-spin"/>
                                    ) : (
                                        <>
                                            <KeyRound className="h-5 w-5"/>
                                            <span>Vérifier l'OTP</span>
                                        </>
                                    )}
                                </button>

                                <div className="text-center">
                                    <button
                                        type="button"
                                        onClick={handleResendOtp}
                                        disabled={resendTimer > 0 || loading}
                                        className="text-primary hover:text-primary font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {resendTimer > 0
                                            ? `Renvoyer l'OTP dans ${resendTimer}s`
                                            : 'Renvoyer l\'OTP'}
                                    </button>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => setStep('phone')}
                                    className="w-full text-gray-600 hover:text-gray-800 font-medium"
                                >
                                    Change le numéro de téléphone
                                </button>
                            </form>
                        )}
                    </div>
                </div>
         </div>
    );
};

export default OtpScreen;
